import { useAppStore } from '@/stores/modules/app'
import type { ConfigFeature } from '@/types/api/config'
import type { RouteMetaMiddleware } from '@/types/shims-vue-router'

export const featureEnabled = (requiredFeatures: ConfigFeature['name'][]) => {
  const middleware: RouteMetaMiddleware = (params) => {
    const appStore = useAppStore(params?.store)
    const features = appStore.config?.features ?? []

    return features.some(
      (f) => requiredFeatures.includes(f.name) && f.enabled === true,
    )
  }

  return middleware
}
